import {
  type PimProductV11,
  PrescriptionPrescriptionTypeEnum,
} from '@redteclab/api/clients/bully'

import {
  type ProductPrices,
  useProductPrices,
} from '../../../ProductBuyBox/hooks/useProductPrices'
import { useProductPageContext } from '../../../productPageContext'

/**
 * This hook extracts logic from the ProductAttributeTileWithPrice component, returning the booleans and data Product Context and ProductPrices needed to render the various states
 */

export const useProductAttributeTileWithPriceData = (
  size: 'large' | 'small',
  candidateVariant: PimProductV11,
): {
  currentPrescriptionType: PrescriptionPrescriptionTypeEnum
  isLarge: boolean
  isMasterPage: boolean
  isPrivatePrescription: boolean
  isVariantNotAvailable: boolean
  prices: ProductPrices
} => {
  const { currentPrescriptionType, isMasterPage, offerId } =
    useProductPageContext()
  const prices: ProductPrices = useProductPrices({
    currentPrescriptionType,
    offerId,
    product: candidateVariant,
  })

  const isLarge = size === 'large'
  const isVariantNotAvailable =
    prices.isProductNotInCatalog ||
    prices.isProductOutOfSale ||
    prices.isProductOutOfStock ||
    !prices.displayPrice
  const isPrivatePrescription =
    currentPrescriptionType ===
    PrescriptionPrescriptionTypeEnum.PrivatePrescription

  return {
    currentPrescriptionType,
    isLarge,
    isMasterPage,
    isPrivatePrescription,
    isVariantNotAvailable,
    prices,
  }
}
